module.exports = __webpack_public_path__ + "static/media/next-steps-1.a614dcd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/next-steps-1.png
// module id = 2633
// module chunks = 0